import { request } from '@/utils/request'
import { packCriteria } from '@/utils/filters'
import { createScreener } from '@/utils/screener'

export const FIELDS = {
    accessionNumber: 'Accession Number',
    createdDate: 'Imported At',
    documentType: 'Form',
    issuerFactSetEntityId: 'Issuer FactSet Id',
    filedAsOfDate: 'Filing Date',
    issuerCik: 'Issuer CIK',
    issuerName: 'Issuer',
    reportingOwnerCik: 'Owner CIK',
    reportingOwnerName: 'Owner',
    reportingOwnerFactSetEntityId: 'Owner FactSet Id',
}

const PAGE_SIZE = 20

export function formatEntityOption(entity) {
    if (entity.symbol) {
        return `${entity.symbol} | ${entity.name} [${entity.providerEntityId}]`
    } else {
        return `${entity.name} [${entity.providerEntityId}]`
    }
}

export function ownershipFilingsGet(accessionNumber, signal) {
    return request.get(`/api/providers/sec/ownership/filings/${accessionNumber}`, null, { signal })
}

export function ownershipFilingsPut(accessionNumber, filing) {
    return request.put(`/api/providers/sec/ownership/filings/${accessionNumber}`, filing)
}

export function ownershipRecordPut(accessionNumber, sequenceNumber, record) {
    return request.put(`/api/providers/sec/ownership/filings/${accessionNumber}/records/${sequenceNumber}`, record)
}

export function addDeletionAmendment(accessionNumber, amendedRecord) {
    return request.post(`/api/providers/sec/ownership/filings/${accessionNumber}/records`, {
        amendsAccessionNumber: amendedRecord.accessionNumber,
        amendsSequenceNumber: amendedRecord.sequenceNumber,
    })
}

export function destroyDeletionAmendment(accessionNumber, sequenceNumber) {
    return request.delete(`/api/providers/sec/ownership/filings/${accessionNumber}/records/${sequenceNumber}`)
}

export async function ownershipFilingsSearch(criteria, page, sort, facets, signal) {
    const { content } = await request.post(
        '/api/providers/sec/ownership/filings/search',
        {
            criteria: packCriteria(criteria),
            facets,
            ...page,
            sortField: sort?.field ?? null,
            sortDirection: sort?.direction ?? null,
        },
        { signal }
    )

    return content
}

export function setFsymIds(accessionNumber, map) {
    return request.put(`/api/providers/sec/ownership/filings/${accessionNumber}/fsyms`, map)
}

export function createOwnershipFilingsScreener(options = {}) {
    return createScreener(ownershipFilingsSearch, 'filings', options)
}
